import type { IconData } from '@stacksjs/iconify-core'

export const imageSaturationFlat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M43.5 27.889C43.5 38.239 34.697 46.5 24 46.5S4.5 38.238 4.5 27.889c0-5.598 3.258-10.998 6.843-15.29c3.626-4.339 7.805-7.801 10.075-9.552a4.214 4.214 0 0 1 5.164 0c2.27 1.75 6.45 5.213 10.075 9.552c3.585 4.292 6.843 9.692 6.843 15.29\"/><path fill=\"#2859c5\" d=\"M21.623 11.777c1.015-.78 2.377-.003 2.377 1.184V37c0 1.079-.894 2.056-2.086 1.952C15.827 38.425 11 33.487 11 27.407c0-3.597 2.132-7.06 4.415-9.766c2.312-2.74 4.933-4.885 6.208-5.864\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default imageSaturationFlat
